import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { OrderItem } from './order-item';
import { Project } from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import { ProjectStatus } from 'projects/app-misc/src/app/modules/project-misc/data/project/statuses/project-status';
import { Vendor } from '../../vendor/data/vendor';
import { ShortObject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-json-object';
import { OrderStockInfo } from 'projects/desktop/src/app/modules/order/data/order-stock-info';

@JsonObject('model.cv.Order')
export class Order extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(DateConverter, 'createdDate')
    createdDate?: Date;

    @JsonProperty(DateConverter, 'expectedSubmitDate')
    expectedSubmitDate?: Date;

    @JsonProperty(DateConverter, 'submittedDate')
    submittedDate?: Date;

    @JsonProperty(DateConverter, 'deliveredDate')
    deliveredDate?: Date;

    @JsonProperty(DateConverter, 'expectedDeliveryDate')
    expectedDeliveryDate?: Date;

    @JsonProperty(DateConverter, 'confirmedDate')
    confirmedDate?: Date;

    @JsonProperty([OrderItem], 'items')
    items?: OrderItem[];

    @JsonProperty([Number], 'materialIds')
    materialIds = [];

    @JsonProperty(String, 'notes')
    notes: string;

    @JsonProperty(String, 'number')
    number: string;

    @JsonProperty(DateConverter, 'orderedDay')
    orderedDay?: Date;

    @JsonProperty(ShortObject, 'project')
    project?: ShortObject;

    @JsonProperty(ProjectStatus, 'status')
    status?: ProjectStatus

    @JsonProperty(Vendor, 'vendor')
    vendor?: Vendor

    total = 0;

    orderStockInfos?: OrderStockInfo[]

}
